import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingPopupService } from '@app/main/main-content/floating-popup-manager/services/floating-popup.service';
import { FloatingPopupWindowComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-window/floating-popup-window.component';
import { FloatingPopupHeaderActionsComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-header-actions/floating-popup-header-actions.component';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';

@Component({
  selector: 'gc-floating-popup',
  standalone: true,
  imports: [CommonModule, FloatingPopupWindowComponent, FloatingPopupHeaderActionsComponent],
  templateUrl: './floating-popup.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingPopupComponent {
  public readonly service = inject(FloatingPopupService);

  public popup = input.required<IFloatingPopupInstance>();
}
